import { useEffect, useState } from "react";
import { Loader2, ZoomIn, ZoomOut, Maximize2 } from "lucide-react";
import { api } from "../../lib/api";

export function PageViewer({ fileId, page }) {
  const [src, setSrc] = useState("");
  const [zoom, setZoom] = useState(1);
  const [error, setError] = useState("");
  useEffect(() => {
    let url = "";
    setSrc("");
    setError("");
    api.get(`/files/${fileId}/page/${page}`, { responseType: "blob" })
      .then((r) => { url = URL.createObjectURL(r.data); setSrc(url); })
      .catch(() => setError("Page impossible à afficher"));
    return () => { if (url) URL.revokeObjectURL(url); };
  }, [fileId, page]);
  const z = (d) => setZoom((v) => Math.min(4, Math.max(0.5, +(v + d).toFixed(2))));
  return (
    <div className="space-y-2" data-testid="pm-page-viewer">
      <div className="flex items-center gap-1">
        <button className="tl-btn tl-btn-ghost tl-btn-sm" onClick={() => z(-0.25)} aria-label="Dézoomer" data-testid="pm-zoom-out"><ZoomOut size={16} /></button>
        <span className="tl-mono text-xs w-12 text-center" data-testid="pm-zoom-level">{Math.round(zoom * 100)}%</span>
        <button className="tl-btn tl-btn-ghost tl-btn-sm" onClick={() => z(0.25)} aria-label="Zoomer" data-testid="pm-zoom-in"><ZoomIn size={16} /></button>
        <button className="tl-btn tl-btn-ghost tl-btn-sm" onClick={() => setZoom(2.5)} data-testid="pm-zoom-bottom">Zoom manuscrits</button>
        <button className="tl-btn tl-btn-ghost tl-btn-sm" onClick={() => setZoom(1)} aria-label="Ajuster" data-testid="pm-zoom-reset"><Maximize2 size={16} /></button>
      </div>
      <div className="border rounded-lg bg-slate-100 overflow-auto h-[70vh]" data-testid="pm-page-scroll">
        {error && <p className="p-4 text-sm text-red-700">{error}</p>}
        {!src && !error && <div className="p-6 grid place-items-center"><Loader2 className="animate-spin" /></div>}
        {src && <img src={src} alt={`Page ${page}`} style={{ width: `${zoom * 100}%`, maxWidth: "none" }} className="block" data-testid="pm-page-image" />}
      </div>
    </div>
  );
}
